var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-skeleton-loader',{ref:"skeleton",staticClass:"mx-auto",attrs:{"type":_vm.type}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }